import { im_proto } from '../../proto/index.js';

const SEND_MESSAGE = 'v1/message/send';
// 混链拉消息
const GET_MESSAGES_BY_USER = 'v1/message/get_by_user';
const GET_MESSAGES_BY_USER_INIT_V2 = 'v2/message/get_by_user_init';
// 单链拉消息
const GET_CONVERSATION_LIST = 'v1/conversation/get_list';
const GET_MESSAGES_BY_CONVERSATION = 'v1/message/get_by_conversation';
// 上下线
const SEND_ONLINE = 'v1/account/online';
const SEND_OFFLINE = 'v1/account/offline';
// 会话操作
const MARK_CONVERSATION_DELETE = 'v1/conversation/delete';
const MARK_CONVERSATION_READ_V3 = 'v3/conversation/mark_read';
const GET_CONVERSATION_INFO_V2 = 'v2/conversation/get_info';
const CREATE_CONVERSATION_V2 = 'v2/conversation/create';
const GET_CONVERSATION_INFO_LIST_V2 = 'v2/conversation/get_info_list';
const GET_CONVERSATION_INFO_LIST_BY_FAVORITE_V2 = 'v2/conversation/get_by_favorite';
const GET_CONVERSATION_INFO_LIST_BY_TOP_V2 = 'v2/conversation/get_by_top';
// 群会话操作
const CONVERSATION_PARTICIPANTS_LIST = 'v1/conversation/participants_list';
const ADD_CONVERSATION_PARTICIPANTS = 'v1/conversation/add_participants';
const REMOVE_CONVERSATION_PARTICIPANTS = 'v1/conversation/remove_participants';
const LEAVE_CONVERSATION = 'v1/conversation/leave';
const UPDATE_CONVERSATION_PARTICIPANT = 'v1/conversation/update_participant';
const DISSOLVE_CONVERSATION = 'v1/conversation/dissolve';
// 消息操作
const DELETE_MESSAGE = 'v1/message/delete';
const RECALL_MESSAGE = 'v1/message/recall';
// 设置消息属性
const SET_PROPERTY = 'v1/message/set_property';
// 会话信息相关, 共享的会话设置
const SET_CONVERSATION_CORE_INFO = 'v1/conversation/set_core_info';
const UPSERT_CONVERSATION_CORE_EXT_INFO = 'v1/conversation/upsert_core_ext_info';
// 用户的会话设置
const SET_CONVERSATION_SETTING_INFO = 'v1/conversation/set_setting_info';
const UPSERT_CONVERSATION_SETTING_EXT_INFO = 'v1/conversation/upsert_settings_ext';
const GET_CONVERSATION_PARTICIPANTS_READ_INDEX_V3 = 'v3/conversation/get_read_index';
const GET_CONVERSATION_PARTICIPANTS_MIN_INDEX_V3 = 'v3/conversation/get_min_index';
// 陌生人相关
const GET_STRANGER_CONVERSATION_LIST = 'v1/stranger/get_conversation_list';
const GET_STRANGER_MESSAGES_IN_CONVERSATION = 'v1/stranger/get_messages';
const DELETE_STRANGER_MESSAGE = 'v1/stranger/delete_message';
const DELETE_STRANGER_CONVERSATION = 'v1/stranger/delete_conversation';
const DELETE_ALL_STRANGER_CONVERSATIONS = 'v1/stranger/delete_all_conversations';
const MARK_STRANGER_CONVERSATION_READ = 'v1/stranger/mark_read_conversation';
const MARK_ALL_STRANGER_CONVERSATIONS_READ = 'v1/stranger/mark_read_all_conversations';
// Action相关
const SEND_USER_ACTION = 'v1/client/user_action';
const SEND_INPUT_STATUS = 'v1/client/input_status';
// 音视频消息
const GET_MEDIA_UPLOAD_TOKEN = 'v1/media/get_upload_token';
const GET_MEDIA_URLS = 'v1/media/get_urls';
const GET_USER_CONVERSATION_LIST = 'v1/conversation/list';
const BROADCAST_SEND_MESSAGE = 'v1/broadcast/send_message';
const BROADCAST_RECV_MESSAGE = 'v1/broadcast/recv_message';
const BROADCAST_USER_COUNTER = 'v1/broadcast/user_counter';
const CLIENT_ACK = 'v1/client/ack';
const CREATE_VOIP = 'v1/voip/create';
const CALL_VOIP = 'v1/voip/call';
const UPDATE_VOIP = 'v1/voip/update';
const HEARTBEAT_CHANNEL = 'v1/channel/heartbeat';
const PROFILE_GET_INFO = 'v1/profile/get_info';
const REPORT_CLIENT_METRICS = 'v1/client/report_metrics';
const GET_CONFIGS = 'v1/config/get';
const GET_MESSAGE_BY_INIT = 'v1/message/get_message_by_init';
const MODIFY_MESSAGE_EXT = 'v1/message/modify_ext';
// TODO: 换成proto的 imcmd 定义
const cmdUrlMap = {
    [im_proto.IMCMD.SEND_MESSAGE]: SEND_MESSAGE,
    200: GET_MESSAGES_BY_USER,
    203: GET_MESSAGES_BY_USER_INIT_V2,
    300: GET_CONVERSATION_LIST,
    301: GET_MESSAGES_BY_CONVERSATION,
    400: SEND_ONLINE,
    401: SEND_OFFLINE,
    410: SEND_USER_ACTION,
    411: SEND_INPUT_STATUS,
    603: MARK_CONVERSATION_DELETE,
    608: GET_CONVERSATION_INFO_V2,
    609: CREATE_CONVERSATION_V2,
    610: GET_CONVERSATION_INFO_LIST_V2,
    611: GET_CONVERSATION_INFO_LIST_BY_FAVORITE_V2,
    612: GET_CONVERSATION_INFO_LIST_BY_TOP_V2,
    614: DISSOLVE_CONVERSATION,
    605: CONVERSATION_PARTICIPANTS_LIST,
    650: ADD_CONVERSATION_PARTICIPANTS,
    651: REMOVE_CONVERSATION_PARTICIPANTS,
    652: LEAVE_CONVERSATION,
    655: UPDATE_CONVERSATION_PARTICIPANT,
    701: DELETE_MESSAGE,
    702: RECALL_MESSAGE,
    705: SET_PROPERTY,
    902: SET_CONVERSATION_CORE_INFO,
    904: UPSERT_CONVERSATION_CORE_EXT_INFO,
    921: SET_CONVERSATION_SETTING_INFO,
    922: UPSERT_CONVERSATION_SETTING_EXT_INFO,
    1001: GET_STRANGER_CONVERSATION_LIST,
    1002: GET_STRANGER_MESSAGES_IN_CONVERSATION,
    1003: DELETE_STRANGER_MESSAGE,
    1004: DELETE_STRANGER_CONVERSATION,
    1005: DELETE_ALL_STRANGER_CONVERSATIONS,
    1006: MARK_STRANGER_CONVERSATION_READ,
    1007: MARK_ALL_STRANGER_CONVERSATIONS_READ,
    2000: GET_CONVERSATION_PARTICIPANTS_READ_INDEX_V3,
    2001: GET_CONVERSATION_PARTICIPANTS_MIN_INDEX_V3,
    2002: MARK_CONVERSATION_READ_V3,
    2003: GET_MEDIA_UPLOAD_TOKEN,
    2004: GET_MEDIA_URLS,
    2006: GET_USER_CONVERSATION_LIST,
    2007: BROADCAST_SEND_MESSAGE,
    2008: BROADCAST_RECV_MESSAGE,
    2009: BROADCAST_USER_COUNTER,
    2010: CLIENT_ACK,
    2011: CREATE_VOIP,
    2012: CALL_VOIP,
    2013: UPDATE_VOIP,
    2014: HEARTBEAT_CHANNEL,
    2015: PROFILE_GET_INFO,
    2016: REPORT_CLIENT_METRICS,
    2017: GET_CONFIGS,
    [im_proto.IMCMD.GET_MESSAGE_BY_INIT]: GET_MESSAGE_BY_INIT,
    [im_proto.IMCMD.MODIFY_MESSAGE_EXT]: MODIFY_MESSAGE_EXT,
    [im_proto.IMCMD.UNREAD_COUNT_REPORT]: 'v1/client/unread_count',
    [im_proto.IMCMD.SEND_MESSAGE_P2P]: 'v1/send_message/p2p',
    [im_proto.IMCMD.BATCH_GAT_CONVERSATION_PARTICIPANTS_READINDEX]: 'v1/conversation/batch_get_conversation_participants_readindex',
    [im_proto.IMCMD.GET_CONVERSATIONS_CHECKINFO]: 'v1/conversation/get_checkinfo',
    [im_proto.IMCMD.GET_MESSAGES_CHECKINFO_IN_CONVERSATION]: 'v1/message/get_checkinfo',
    [im_proto.IMCMD.MARK_MESSAGE]: 'v1/message/mark',
    [im_proto.IMCMD.PULL_MARK_MESSAGE]: 'v1/message/pull_mark',
    [im_proto.IMCMD.GET_CONVERSATION_CORE_INFO]: 'v1/conversation/get_core_info',
    [im_proto.IMCMD.GET_UNREAD_COUNT]: 'v1/client/get_unread_count',
    [im_proto.IMCMD.BLOCK_MEMBERS]: 'v1/conversation/block_member',
    [im_proto.IMCMD.BLOCK_CONVERSATION]: 'v1/conversation/block_conversation',
    [im_proto.IMCMD.CHECK_IN_BLOCKLIST]: 'v1/blocklist/check',
    [im_proto.IMCMD.SET_BLOCKLIST]: 'v1/blocklist/set',
    [im_proto.IMCMD.GET_BLOCKLIST]: 'v1/blocklist/get',
    [im_proto.IMCMD.BATCH_UNMARK_MESSAGE]: 'v1/message/batch_unmark',
    [im_proto.IMCMD.MARK_MSG_UNREAD_COUNT_REPORT]: 'v1/message/report_mark_count',
    [im_proto.IMCMD.MARK_MSG_GET_UNREAD_COUNT]: 'v1/message/get_mark_count',
    [im_proto.IMCMD.GET_MESSAGE_INFO_BY_SERVER_ID]: 'v1/message/get_by_id',
    [im_proto.IMCMD.CLIENT_BATCH_ACK]: 'v1/client/batch_ack',
    [im_proto.IMCMD.AUDIO_RECOGNITION]: 'v1/message/audio_recognition'
};
function getUrl(cmd) {
    var _a;
    return (_a = cmdUrlMap[cmd]) !== null && _a !== void 0 ? _a : '';
}

export { cmdUrlMap, getUrl };
//# sourceMappingURL=urls.js.map
